export default {"src":"/login-app/[GIT_HASH]/_next/static/media/config.808f1c10.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};